var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRocketVerified(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "currentColor",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04574 20.5618C9.31809 19.2895 9.31808 17.2266 8.04574 15.9543C6.7734 14.6819 4.71053 14.6819 3.43819 15.9543C2.57033 16.8221 2.17184 19.3643 2.00618 20.8929C1.93656 21.5353 2.46469 22.0634 3.10709 21.9938C4.63572 21.8282 7.17789 21.4297 8.04574 20.5618Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M17.5 22C19.9853 22 22 19.9853 22 17.5C22 15.0147 19.9853 13 17.5 13C15.0147 13 13 15.0147 13 17.5C13 19.9853 15.0147 22 17.5 22ZM20.0762 16.4801L17.5762 19.4801C17.4413 19.642 17.2445 19.7397 17.034 19.7492C16.8235 19.7588 16.6187 19.6793 16.4697 19.5303L14.9697 18.0303C14.6768 17.7374 14.6768 17.2626 14.9697 16.9697C15.2626 16.6768 15.7374 16.6768 16.0303 16.9697L16.9496 17.8889L18.9238 15.5199C19.189 15.2017 19.6619 15.1587 19.9801 15.4238C20.2983 15.689 20.3413 16.1619 20.0762 16.4801Z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M21.9491 3.05039C22.2532 6.02929 21.1839 9.00969 19.0429 11.1506L18.594 11.5995C18.2393 11.5342 17.8736 11.5 17.5 11.5C14.3424 11.5 11.7545 13.9392 11.5177 17.0361L6.70612 12.2245C6.39567 11.9141 6.40032 11.4061 6.71649 11.09L7.09019 10.7163L5.84576 10.1026L4.26429 9.4367C3.97801 9.31615 3.90931 8.9423 4.13244 8.71917L6.17012 6.68149C6.94392 5.90769 8.10232 5.67442 9.09513 6.09247L9.63049 6.3179L10.8749 6.93154L12.8494 4.95706C14.9903 2.81614 17.9707 1.74685 20.9496 2.05091C21.4798 2.10502 21.895 2.52017 21.9491 3.05039Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRocketVerified);
export default __webpack_public_path__ + "static/media/rocket-verified.9e5d3041eb207116b2fbc50d0a15abbd.svg";
export { ForwardRef as ReactComponent };